import React, { useEffect, useState } from "react";
import qs from "query-string";
import { useHistory } from "react-router";

import Tabs from "app/components/tabs/Tabs";
import Searchinput from "app/components/search-input/Searchinput";
import SelectDropdown from "app/components/select-dropdown/SelectDropdown";
import Loader from "app/loader/Loader";
import { GET_CIRCLE_BY_OPERATOR, GET_OPERATOR_LIST } from "app/api/ApiEndpoints";
import { useGet } from "app/services/http-service";
import { useMutation } from "react-query";
import { NUMBER_FOR_RECHARGE } from "app/context/Types";
import { StoreContext } from "app/context/Store";

function RechargePlans(props) {
  const history = useHistory();
  const { mobileNumber } = qs.parse(location.search);
  const { changeStep, tabTypes, rechargePlansData, visibleTab, setVisibleTab, setOperatorId , setCircleId } =
    props;
  const [searchQuery, setSearchQuery] = React.useState("");
  const [operatorOptions ,setOperatorOptions] = useState([]);
  const authToken = localStorage.getItem("tspAuthToken");
  const [currentOperator, setCurrentOperator] = React.useState({});
  const [currentCircle, setCurrentCircle] = React.useState({});
  const context = React.useContext(StoreContext);

  useEffect(() => {
    context.dispatch({
      type: NUMBER_FOR_RECHARGE,
      payload: { ...context.state, rechargeNumber: mobileNumber },
    });
  },[mobileNumber]);

  useEffect(()=>{
    if(rechargePlansData && rechargePlansData.length > 0){
      setCurrentCircle(
        {
          value: rechargePlansData[0]?.circleId,
          label: rechargePlansData[0]?.circleName,
        }
      );
      setCurrentOperator(
        {
          value: rechargePlansData[0]?.operatorId,
          label: rechargePlansData[0]?.operatorName,
        }
      );
    }

  },[rechargePlansData]);

  const [circles, setCircles] = React.useState([]);

  const { mutate: operatorListMutation } = useMutation(
    (data) => useGet(data),{
      onSuccess:(data)=>{
        if (data) {
          let operators = data?.content?.map((plan) => ({
            value: plan.operatorCode,
            label: plan.operatorName,
          }));
          setOperatorOptions(operators ? operators : []);
        }
      },
      onError:(error)=>{
       showFailureAlert(error.message ? error.message : "Something went wrong!");
      },
    }
  );

  React.useEffect(() => {
    const queryParams = {
      page: 0,
      size: 10,
      sortAscending: true,
    };
    const body = {
      url: `${GET_OPERATOR_LIST}?${qs.stringify(queryParams)}`,
      token: authToken,
    };
    operatorListMutation(body);
  }, []);

  React.useEffect(() => {
    const queryParams = {
      operatorId: currentOperator?.value,
      operatorName: currentOperator?.label,
      page: 0,
      size: 100,
      sortAscending: true,
      sortingField: "circleName",
    };
    const body = {
      url: `${GET_CIRCLE_BY_OPERATOR}?${qs.stringify(queryParams)}`,
      token: authToken,
    };
    circleByOperatorMutation(body);
  }, [currentOperator]);

  const {
    mutate: circleByOperatorMutation,
  } = useMutation((data) => useGet(data),{
    onSuccess:(data)=>{
      if (data) {
        let circles = data?.content?.map((plan) => ({
          value: plan.circleId,
          label: plan.circleName,
        }));
        setCircles(circles ? circles : []);
      }
    },
    onError:(error)=>{
     showFailureAlert(error.message ? error.message : "Something went wrong!");
    }
  });

  const handleOnChange = (event) => {
    setSearchQuery(event.target.value);
    setVisibleTab(null);
  };

  const filteredRechargePlans = React.useMemo(() => {
    const query = searchQuery.toUpperCase();
    if (rechargePlansData && searchQuery !== "") {
      return rechargePlansData?.filter((plan) =>
        plan?.price.toUpperCase().includes(query),
      );
    } else {
      return rechargePlansData || [];
    }
  }, [rechargePlansData, searchQuery]);

  return (
    <div className="col-md-8 p-0">
      <div className="c-list pt-0 d-flex justify-content-between">
        <h3 className="font_600">{mobileNumber}</h3>
        <div>
          <i className="material-icons" onClick={()=>{ history.push(`/recharge/MOBILE%20PREPAID?phoneNumber=${mobileNumber}`);}}>
          edit
        </i>
        </div>
      </div>
      <div className="row mt-4">
        <div className="col-md-6">
          <SelectDropdown
            dropdownOptions={operatorOptions}
            defaultSelected={currentOperator}
            onChange = {(data)=>{ setCurrentOperator(data);setOperatorId(data.value);}}
          />
        </div>
        <div className="col-md-6">
          <SelectDropdown
            dropdownOptions={circles}
            defaultSelected={currentCircle}
            onChange = {(data)=>{setCurrentCircle(data);setCircleId(data.value ? data.value : data.label); }}
          />
        </div>
      </div>
      <div className="recharge-options">
        <Searchinput
          title="Search For A Plan, Eg 499 Or 28 Days"
          onChange={handleOnChange}
          value={searchQuery}
        />
        <Tabs
          tabTypes={tabTypes}
          visibleTab={visibleTab}
          setVisibleTab={setVisibleTab}
        />
        {!filteredRechargePlans && <Loader loaderMessage="Loading..." />}
        {filteredRechargePlans && filteredRechargePlans?.length === 0 && (
          <p className="text-center my-2">No Plan Found</p>
        )}
        <div>
          {filteredRechargePlans &&
            filteredRechargePlans?.map((item, index) => (
              <div
                key={index}
                className="rec-option card p-2 mb-4 cursor-pointer reacharge-planp-box"
                onClick={() => {
                  changeStep(4);
                  history.push(`/mobile-recharge/browse-plans/${item?.id}?mno=${mobileNumber}`);
                }}
              >
                <div className="d-flex justify-content-between recharge-card">
                  <div>
                    <p>Validity</p>
                    <h3>{item?.validity}</h3>
                  </div>
                  {/* <div>
                    <p>Data</p>
                    <h3>2 GB</h3>
                  </div> */}
                  <div>
                    <button type="button" className="btn btn-primary-outline">
                      ₹{item.price}
                    </button>
                  </div>
                </div>
                <p className="mt-1">{item.packageDescription}</p>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
}

export default RechargePlans;
